/* global axios */
import ApiClient from './ApiClient';

// Modelos de e-mail (construtor): CRUD + catálogo, galeria, preview no
// servidor, envio de teste, duplicar, kit da marca e IA.
class MarketingEmailTemplatesAPI extends ApiClient {
  constructor() {
    super('marketing_email_templates', { accountScoped: true });
  }

  catalog() {
    return axios.get(`${this.url}/catalog`);
  }

  gallery() {
    return axios.get(`${this.url}/gallery`);
  }

  createFromPreset(preset, attrs = {}) {
    return axios.post(this.url, { preset, marketing_email_template: attrs });
  }

  preview(source, { dark = false } = {}) {
    return axios.post(`${this.url}/preview`, {
      marketing_email_template: source,
      dark,
    });
  }

  sendTest(id, inboxId) {
    return axios.post(`${this.url}/${id}/send_test`, { inbox_id: inboxId });
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  applyBrandKit(id) {
    return axios.post(`${this.url}/${id}/apply_brand_kit`);
  }

  aiCompose({ id, brief, mode }) {
    return axios.post(`${this.url}/ai_compose`, { id, brief, mode });
  }

  aiEdit(id, instruction, source) {
    return axios.post(`${this.url}/${id}/ai_edit`, {
      instruction,
      marketing_email_template: source,
    });
  }

  aiSubjects(id, source) {
    return axios.post(`${this.url}/${id}/ai_subjects`, {
      marketing_email_template: source,
    });
  }
}

export default new MarketingEmailTemplatesAPI();
